import { useEffect } from "react";

export const APP_TITLE = "BDS POS System";

/** Keeps the browser tab consistent: "Dashboard | BDS POS System". */
export const usePageTitle = (section) => {
  useEffect(() => {
    document.title = section ? `${section} | ${APP_TITLE}` : APP_TITLE;
  }, [section]);
};

export default usePageTitle;
